import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import type { Program } from '../../types/content';
interface ProgramCardProps {
  program: Program;
  selected: boolean;
  onSelect: () => void;
}
export function ProgramCard({
  program,
  selected,
  onSelect
}: ProgramCardProps) {
  return <button type="button" onClick={onSelect} aria-pressed={selected} aria-controls="program-detail" className={`group flex h-full w-full flex-col overflow-hidden rounded bg-white text-left ring-1 transition-[box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 ${selected ? 'ring-2 ring-brand' : 'ring-line hover:ring-ink/30'}`} data-id="element-157" data-mp="21es5ijfai034">
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-ink" data-id="element-158" data-mp="1hqswbd0dj0zt">
        <img src={program.image} alt={program.imageAlt} className="h-full w-full" style={{
        objectPosition: program.imagePosition,
        objectFit: program.imageFit ?? 'cover'
      }} loading="lazy" data-id="element-159" data-mp="1hsvwgpv8qai9" />
        <span className="absolute left-3 top-3 rounded-sm bg-ink px-2.5 py-1 text-[13px] font-semibold text-white" data-id="element-160" data-mp="2w1acah81osrw">
          {program.audience}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5 lg:p-6" data-id="element-161" data-mp="3539v9f2me6xh">
        <h3 className="font-display text-[1.75rem] font-bold uppercase leading-none" data-id="element-162" data-mp="353tago0vyh7t">{program.name}</h3>
        <p className="text-pretty mt-3 text-[15px] leading-relaxed text-muted" data-id="element-163" data-mp="3a1bkyiujx4hx">{program.summary}</p>
        <span className={`mt-auto inline-flex items-center gap-2 pt-5 text-[15px] font-semibold ${selected ? 'text-brand' : 'text-ink'}`} data-id="element-164" data-mp="2cc9myrx9ah00">
          {selected ? 'Showing details' : 'See program details'}
          <ArrowDownIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-y-0.5" aria-hidden="true" data-id="element-165" data-mp="2r38tlxej6vgy" />
        </span>
      </div>
    </button>;
}